import React, { useEffect, useState } from 'react';
import styles from './NonReservable.module.css';
import { FaChargingStation } from 'react-icons/fa';
import { IoLocationSharp } from "react-icons/io5";

import { TbChargingPile } from "react-icons/tb";
import ChargerItem from './components/ChargerItem/ChargerItem';
import { toast } from 'react-toastify';
import ChargerItemLoader from './components/ChargerItemLoader';
import {useWebSocket} from '../../../../Utils/WebSocketContext';
// import ChargerItem from './components/ChargerItem';



const NonReservable = ({ isLoading, locationData, chargingStations, locationTimezone, localTimezone, handleNewBooking, setIsSessionFormShow, isSessionFormShow, setSelectedChargerForNonRes, onSlotClick }) => {
  const [showChargerTime, setShowChargerTime] = useState(false);
  // console.log("chargingStations", chargingStations);

  const webSocket = useWebSocket();
  const [eventType, setEventType] = useState("");
  const [connectorStatus, setConnectorStatus] = useState("");
  let nonResChargers = {}
  chargingStations.sort((a,b)=>a.orderingNumber - b.orderingNumber);
  chargingStations.map((connector)=>{
    if(connector?.id in nonResChargers){
      nonResChargers[connector?.id].push(connector);
    }
    else{
      nonResChargers[connector?.id] = [connector];
    }
  })

  

  // console.log("isSessionFrom show : ", isSessionFormShow)
  useEffect(() => {
    let offset = getTimeZoneOffsetTwoTimezone(localTimezone, locationTimezone); 
    if (offset !== 0) {
      setShowChargerTime(true);
    } else {
      setShowChargerTime(false);
    }
  }, [locationTimezone, localTimezone]);

  function createMessage(type, message) {
    if (type == 'error') {
      toast.error(message);
    } else {
      toast.success(message);
    }
  }

  function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
    const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
    const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
    const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();
    return timeDifferenceInMilliseconds;
  }


  return (
    <div className={styles['non-reservable-chargers']}>
      <div>
        {showChargerTime && (
          <div className={styles['top-charger-timezone']}>
            <span className={styles['border-animation']}>
              {locationTimezone}<FaChargingStation />
            </span>
          </div>
        )}

        {!isLoading ?
          <div className={styles['chargers-container']}>
            {(chargingStations && Object.keys(nonResChargers).length > 0) ?
              <div className={styles['chargers-list']}>
                {(
                  Object.keys(nonResChargers).map((key, index) => (
                    <ChargerItem key={index} stationVal={nonResChargers[key]} locationData={locationData} makeToast={createMessage} handleNewBooking={handleNewBooking} setIsSessionFormShow={setIsSessionFormShow} isSessionFormShow={isSessionFormShow} setSelectedChargerForNonRes={setSelectedChargerForNonRes} onSlotClick={onSlotClick} />
                  ))
                )}
                {/* {(
                  chargingStations.map((station, index) => (
                    <ChargerItem key={index} station={station} locationData={locationData} makeToast={createMessage} handleNewBooking={handleNewBooking} setIsSessionFormShow={setIsSessionFormShow} isSessionFormShow={isSessionFormShow} setSelectedChargerForNonRes={setSelectedChargerForNonRes}/>
                  ))
                )} */}
              </div>
              :
              <div className={styles['no-charging-stations']}>
                <p>No charging stations available.</p>
              </div>
            }
          </div>
          :
          <div className={styles['chargers-container']}>
            <div className={styles['chargers-list']}>
              <ChargerItemLoader />
              <ChargerItemLoader />
            </div>
          </div>
        }


        {showChargerTime && (
          <div className={styles['bottom-charger-timezone']}>
            <span className={styles['border-animation']}>
              {locationTimezone} <FaChargingStation />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NonReservable;
